import {IPropertyGallery} from "../../../property/types/IPropertyGallery";
import {IOfferGallery} from "../../detail/types/IOfferGallery";
import {IConstructionGalleryResponse} from "../../types/ConstructionGallery";
import {OfferModalActiveTab} from "../../types/OfferModalActiveTab";
import {ITrackAmplitudeOpenGalleryParams} from "./track_amplitude_open_gallery";

interface IGetOpenGalleryAmplitudePayloadParams {
    modalState: OfferModalActiveTab | null;
    mediaTabNavigation: "initial" | "tab_switch";
    offerId: number | string;
    propertyId?: number;
    galleryPictures?: IOfferGallery | null;
    propertyGalleryPictures?: IPropertyGallery | null;
    constructionGalleryPictures?: IConstructionGalleryResponse | null;
    isAuthenticated: boolean;
}

export const getOpenGalleryAmplitudePayload = (params: IGetOpenGalleryAmplitudePayloadParams): ITrackAmplitudeOpenGalleryParams | null => {
    const {modalState, mediaTabNavigation, offerId, propertyId, galleryPictures, propertyGalleryPictures, constructionGalleryPictures, isAuthenticated} =
        params;
    const common = {offerId, propertyId, mediaTabNavigation, contentAccess: "full"} as const;

    switch (modalState) {
        case OfferModalActiveTab.GALLERY: {
            // +1 because the offer's main image is shown in the gallery but is not part of the gallery pictures arrays
            const photosTotal = 1 + (galleryPictures?.length ?? 0) + (propertyGalleryPictures?.length ?? 0);
            return {...common, galleryView: "grid", photoSection: "gallery", photosTotal: photosTotal > 0 ? photosTotal : undefined};
        }
        case OfferModalActiveTab.MAP:
            return {...common, galleryView: "map", photoSection: "map"};
        case OfferModalActiveTab.PLAN:
            return {...common, galleryView: "grid", photoSection: "floor_plan"};
        case OfferModalActiveTab.CONSTRUCTION_GALLERY: {
            if (!isAuthenticated) {
                return {...common, galleryView: "gated", photoSection: "construction_photos", contentAccess: "gated"};
            }
            return {
                ...common,
                galleryView: "grid",
                photoSection: "construction_photos",
                photosTotal: constructionGalleryPictures?.length
            };
        }
        default:
            return null;
    }
};
import {IPropertyGallery} from "../../../property/types/IPropertyGallery";
import {IOfferGallery} from "../../detail/types/IOfferGallery";
import {IConstructionGalleryResponse} from "../../types/ConstructionGallery";
import {OfferModalActiveTab} from "../../types/OfferModalActiveTab";
import {ITrackAmplitudeOpenGalleryParams} from "./track_amplitude_open_gallery";

interface IGetOpenGalleryAmplitudePayloadParams {
    modalState: OfferModalActiveTab | null;
    mediaTabNavigation: "initial" | "tab_switch";
    offerId: number | string;
    propertyId?: number;
    galleryPictures?: IOfferGallery | null;
    propertyGalleryPictures?: IPropertyGallery | null;
    constructionGalleryPictures?: IConstructionGalleryResponse | null;
    isAuthenticated: boolean;
}

export const getOpenGalleryAmplitudePayload = (params: IGetOpenGalleryAmplitudePayloadParams): ITrackAmplitudeOpenGalleryParams | null => {
    const {modalState, mediaTabNavigation, offerId, propertyId, galleryPictures, propertyGalleryPictures, constructionGalleryPictures, isAuthenticated} =
        params;
    const common = {offerId, propertyId, mediaTabNavigation, contentAccess: "full"} as const;

    switch (modalState) {
        case OfferModalActiveTab.GALLERY: {
            // +1 because the offer's main image is shown in the gallery but is not part of the gallery pictures arrays
            const photosTotal = 1 + (galleryPictures?.length ?? 0) + (propertyGalleryPictures?.length ?? 0);
            return {...common, galleryView: "grid", photoSection: "gallery", photosTotal: photosTotal > 0 ? photosTotal : undefined};
        }
        case OfferModalActiveTab.MAP:
            return {...common, galleryView: "map", photoSection: "map"};
        case OfferModalActiveTab.PLAN:
            return {...common, galleryView: "grid", photoSection: "floor_plan"};
        case OfferModalActiveTab.CONSTRUCTION_GALLERY: {
            if (!isAuthenticated) {
                return {...common, galleryView: "gated", photoSection: "construction_photos", contentAccess: "gated"};
            }
            return {
                ...common,
                galleryView: "grid",
                photoSection: "construction_photos",
                photosTotal: constructionGalleryPictures?.length
            };
        }
        default:
            return null;
    }
};
